







































import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import SearchPolicy from '@/mixins/search-queries/search-policy'
import SearchQuote from '@/mixins/search-queries/search-quote'
import SearchUser from '@/mixins/search-queries/search-user'
import { statusValues, policyTypeValues } from '@/modules/Policy/helpers/policy'
import { Case } from '@/modules/Case/interfaces/case'
import { IPolicyInfoInput } from '@/modules/Policy/interfaces/policy-form'
import { Quote } from '@/modules/Quote/interfaces/quote'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class PolicyFormInfo extends mixins(SearchPolicy, SearchQuote, SearchUser) {
  @Prop({ type: Object as () => IPolicyInfoInput }) value!: IPolicyInfoInput
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote

  statusOptions = statusValues
  typeOptions = policyTypeValues

  get disableType () {
    return !!this.caseInfo || !!(this.quote && this.quote.caseInfo)
  }

  get disablePrior () {
    return !!(this.caseInfo && this.caseInfo.targetPolicy) || !!(this.quote && this.quote.priorTerm)
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
